export enum PreviewOrderByEnums{
    clienteCentroCostos = 1,
    centroCostos = 2

}